import { useState } from "react";

export default function DetachedLoginPage() {
    const [passwordInput, setPasswordInput] = useState("");

    const handleLogin = async () => {
        const res = await fetch("/api/login", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ password: passwordInput }),
        });
        const result = await res.json();
        if (res.ok && result.auth === true) {
            window.location.href = "/upload";
          console.log("Login success");
        } else {
          console.log("Login error");
        }
      };
    
    return(
        <div className="p-4 max-w-md mx-auto">
            <h2 className="text-xl font-bold mb-4">Admin Login</h2>
            <input
                type="password"
                placeholder="Enter password"
                className="border border-gray-300 p-2 rounded w-full max-w-xs mb-2"
                value={passwordInput}
                onChange={(e) => setPasswordInput(e.target.value)}
            />
            <button type="button" class="mt-4 text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700" onClick={handleLogin}>
                Login
            </button>
        </div>
    );
}